import { BaseModel } from '../../_base/crud';

export class OfficeModel extends BaseModel {
  id: number;
  officeUUID: string;
  name: string;
  company: string;
  companyID: number;
  companyUUID: string;
  street_line1: string;
  street_line2: string;
  city: string;
  state_code: string;
  zip_code: string;
  zip4: string;
  country_code: string;
  isActive: boolean;
  prefix: string;
  suffix: string;
  phone: string;
  fax: string;

  clear() {
    this.id = 0;
    this.name = '';
    this.officeUUID = '';
    this.company = '';
    this.companyID = 0;
    this.street_line1 = '';
    this.street_line2 = '';
    this.city = '';
    this.state_code = '';
    this.zip_code = '';
    this.zip4 = '';
    this.country_code = 'US';
    this.isActive = true;
    this.phone = '';
    this.fax = '';
    this.prefix = '';
    this.suffix = '';
  }
}
